import { useAppDispatch, useAppSelector } from './useStore';
import { clear, selectIsAuthenticated, selectUser } from '../store/slices/auth';

/**
 * Hook de autenticação — wrapper sobre o estado Redux de auth.
 */
export function useAuth() {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const userRaw = useAppSelector(selectUser);

  const user = userRaw
    ? { id: userRaw.id, email: userRaw.email, name: userRaw.name }
    : null;

  const logout = () => {
    dispatch(clear());
    if (window.location.pathname !== '/login') {
      window.location.href = '/login';
    }
  };

  return { isAuthenticated, user, logout };
}
